import { gql } from '@apollo/client';

const QUERY = gql`
  query OutstandingReport($organizationId: Int!, $startDate: String!, $endDate: String!) {
    outstandingFinancialReport(input: { startDate: $startDate, endDate: $endDate }, organizationId: $organizationId) {
      amountBilled
      amountDue
      amountPaid
      dueDate
      id
      members
      orderNumber
      orderType
      programSeason
      referenceObjectId
      referenceObjectUrl
      status
      sourceName
      sourceUrl
      sourceItems {
        type
        sourceName
        seasonId
        programSeason
        participantFirstName
        participantLastName
        teamId
        teamName
        type
        divisionId
        divisionName
        linkInfo {
          rootDivisionId
          batchInvoiceId
          invoiceId
          registrationFormId
          registrationId
          organizationId
        }
      }
    }
  }
`;

export default QUERY;
